import Base from 'app/models/base';

import { appUrl } from 'utils/wrappers';

export default Base.extend({
  urlRoot: appUrl('ups_registrations'),
  rootKey: 'ups_registration',
});



// WEBPACK FOOTER //
// ./app/models/ups_registration.js